import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router} from '@angular/router';
import { Location } from '@angular/common';
import { Role } from '../../models/role';
import { RoleService } from '../../services/role.service';
import { ToastrService } from 'ngx-toastr';
import { RoleDto } from '../../dto/role.dto';
import { BaseService } from '../../base.service';

@Component({
  selector: 'app-create-role',
  templateUrl: './create-role.component.html',
  styleUrls: []
})
export class CreateRoleComponent implements OnInit {

  title_component: string;
  title_panel: string;
  role: Role;
  button_status: boolean;
  message: string;
  loading = false;


  public status = [
    { value: true, desc: 'Activo' },
    { value: false, desc: 'Inactivo' }
  ];

  constructor(
    private route: ActivatedRoute,
    private location: Location,
    private roleService: RoleService,
    private toastr: ToastrService,
    private router: Router,
    private baseService: BaseService
  ) { }

  ngOnInit() {

    this.title_component = 'Crear Rol';
    this.baseService.changedComponentName(this.title_component);
    this.title_panel = 'Crear rol';

    this.role = {
      id: null,
      name: '',
      description: '',
      creationUser: '',
      creationDate: '',
      status: this.status[0].value
    };
    this.button_status = true;
  }

  goBack(event): any {
    this.location.back();
  }

  create(value): any {
    this.button_status = false;
    this.loading = true;
    const message = 'Sus datos se han creado con exito.';
    const dto = new RoleDto(value.name, value.description);

    this.roleService.createRole(dto).subscribe(data => {
      if (data) {
        setTimeout(() => {
          this.loading = false;
          this.showSuccess(message);
          this.router.navigate(['/dashboard/role']);
        }, 1000);
      }
    });
  }

  showSuccess(message: string): void {
    this.toastr.success(message, 'Éxito!', {
      timeOut: 6000,
      positionClass: 'toast-top-right'
    });
  }

  showError(message: string): void {
    this.toastr.error(message, 'Error!', {
      timeOut: 6000,
      positionClass: 'toast-top-right'
    });
  }

}



// WEBPACK FOOTER //
// D:/padriana/gorent-panel/src/app/dashboard/role/create-role.component.ts